module.exports = __webpack_public_path__ + "img/drei.069165e8.png";